/**
 * NetXBrand Social Proof Widget v3
 * - Country flags on city names
 * - Tracks popup impressions + clicks in localStorage for admin dashboard
 */
(function () {

  if (window.__netxbrandSPW) return;
  window.__netxbrandSPW = true;

  // ── CONFIG ────────────────────────────────────────────────────────────────
  var CONFIG = {
    types:      ['purchase', 'visitor', 'pageview'],
    interval:   [7000, 13000],
    duration:   5000,
    position:   'bottom-left',
    maxVisible: 3,
  };

  // ── COUNTRY FLAGS (city → flag emoji + country) ───────────────────────────
  var CITY_DATA = {
    // Netherlands
    'Amsterdam':     { flag: '🇳🇱', country: 'Netherlands' },
    'Rotterdam':     { flag: '🇳🇱', country: 'Netherlands' },
    // UK
    'London':        { flag: '🇬🇧', country: 'UK' },
    'Manchester':    { flag: '🇬🇧', country: 'UK' },
    'Edinburgh':     { flag: '🇬🇧', country: 'UK' },
    'Glasgow':       { flag: '🇬🇧', country: 'UK' },
    'Birmingham':    { flag: '🇬🇧', country: 'UK' },
    // Germany
    'Berlin':        { flag: '🇩🇪', country: 'Germany' },
    'Munich':        { flag: '🇩🇪', country: 'Germany' },
    'Hamburg':       { flag: '🇩🇪', country: 'Germany' },
    'Frankfurt':     { flag: '🇩🇪', country: 'Germany' },
    'Cologne':       { flag: '🇩🇪', country: 'Germany' },
    // France
    'Paris':         { flag: '🇫🇷', country: 'France' },
    'Lyon':          { flag: '🇫🇷', country: 'France' },
    'Marseille':     { flag: '🇫🇷', country: 'France' },
    'Nice':          { flag: '🇫🇷', country: 'France' },
    // Sweden
    'Stockholm':     { flag: '🇸🇪', country: 'Sweden' },
    // Italy
    'Milan':         { flag: '🇮🇹', country: 'Italy' },
    'Rome':          { flag: '🇮🇹', country: 'Italy' },
    'Naples':        { flag: '🇮🇹', country: 'Italy' },
    'Turin':         { flag: '🇮🇹', country: 'Italy' },
    'Bologna':       { flag: '🇮🇹', country: 'Italy' },
    'Florence':      { flag: '🇮🇹', country: 'Italy' },
    // Spain
    'Madrid':        { flag: '🇪🇸', country: 'Spain' },
    'Barcelona':     { flag: '🇪🇸', country: 'Spain' },
    'Valencia':      { flag: '🇪🇸', country: 'Spain' },
    'Seville':       { flag: '🇪🇸', country: 'Spain' },
    // Denmark
    'Copenhagen':    { flag: '🇩🇰', country: 'Denmark' },
    // Portugal
    'Lisbon':        { flag: '🇵🇹', country: 'Portugal' },
    'Porto':         { flag: '🇵🇹', country: 'Portugal' },
    // Austria
    'Vienna':        { flag: '🇦🇹', country: 'Austria' },
    // Switzerland
    'Zurich':        { flag: '🇨🇭', country: 'Switzerland' },
    'Geneva':        { flag: '🇨🇭', country: 'Switzerland' },
    'Basel':         { flag: '🇨🇭', country: 'Switzerland' },
    // Norway
    'Oslo':          { flag: '🇳🇴', country: 'Norway' },
    // Finland
    'Helsinki':      { flag: '🇫🇮', country: 'Finland' },
    // Belgium
    'Brussels':      { flag: '🇧🇪', country: 'Belgium' },
    // Ireland
    'Dublin':        { flag: '🇮🇪', country: 'Ireland' },
    // Poland
    'Warsaw':        { flag: '🇵🇱', country: 'Poland' },
    'Krakow':        { flag: '🇵🇱', country: 'Poland' },
    'Gdansk':        { flag: '🇵🇱', country: 'Poland' },
    // Czech Republic
    'Prague':        { flag: '🇨🇿', country: 'Czech Republic' },
    // Hungary
    'Budapest':      { flag: '🇭🇺', country: 'Hungary' },
    // Greece
    'Athens':        { flag: '🇬🇷', country: 'Greece' },
    // Luxembourg
    'Luxembourg':    { flag: '🇱🇺', country: 'Luxembourg' },
    // Estonia
    'Tallinn':       { flag: '🇪🇪', country: 'Estonia' },
    // Latvia
    'Riga':          { flag: '🇱🇻', country: 'Latvia' },
    // Lithuania
    'Vilnius':       { flag: '🇱🇹', country: 'Lithuania' },
    // Canada
    'Toronto':       { flag: '🇨🇦', country: 'Canada' },
    'Vancouver':     { flag: '🇨🇦', country: 'Canada' },
    'Montreal':      { flag: '🇨🇦', country: 'Canada' },
    // USA
    'New York':      { flag: '🇺🇸', country: 'USA' },
    'Los Angeles':   { flag: '🇺🇸', country: 'USA' },
    'Chicago':       { flag: '🇺🇸', country: 'USA' },
    'Boston':        { flag: '🇺🇸', country: 'USA' },
    'San Francisco': { flag: '🇺🇸', country: 'USA' },
    'Miami':         { flag: '🇺🇸', country: 'USA' },
    // Australia / NZ
    'Sydney':        { flag: '🇦🇺', country: 'Australia' },
    'Melbourne':     { flag: '🇦🇺', country: 'Australia' },
    'Auckland':      { flag: '🇳🇿', country: 'New Zealand' },
  };

  var CITIES = Object.keys(CITY_DATA);

  var NAMES = [
    'Emma','Liam','Sophia','Noah','Oliver','Ava','Lucas','Mia','Mason',
    'Isabella','Logan','Charlotte','James','Amelia','Aiden','Harper',
    'Elijah','Evelyn','Jackson','Abigail','Sebastian','Emily','Mateo',
    'Lily','Jack','Mila','Owen','Ella','Henry','Zoe','Alexander',
    'Daniel','Michael','William','Benjamin','Ethan','Jacob','Samuel',
    'David','Joseph','Leo','Julian','Gabriel','Nathan','Thomas',
    'Anthony','Christopher','Matthew','Andrew','Joshua','Ryan',
    'Sofia','Chloe','Grace','Hannah','Victoria','Scarlett','Aria',
    'Layla','Nora','Stella','Lucy','Claire','Anna','Leah',
    'Sarah','Elena','Valentina','Giulia','Sophie','Camila',
    'Eva','Alice','Iris','Freya','Clara','Luca','Marco',
    'Leon','Max','Theo','Jonas','Finn','Oscar',
  ];

  var FALLBACK = [
    { title: 'Premium Hoodie', img: '' }, { title: 'Oversized Tee', img: '' },
    { title: 'Cargo Pants',    img: '' }, { title: 'Bomber Jacket',  img: '' },
    { title: 'Coach Jacket',   img: '' }, { title: 'Knit Sweater',   img: '' },
  ];

  // ── STATS TRACKING ────────────────────────────────────────────────────────
  var STATS_KEY = 'spw_stats';

  function loadStats() {
    try {
      var raw = localStorage.getItem(STATS_KEY);
      return raw ? JSON.parse(raw) : { impressions: 0, clicks: 0, byType: { purchase: 0, visitor: 0, pageview: 0 }, byHour: {}, lastSeen: null };
    } catch(e) {
      return { impressions: 0, clicks: 0, byType: { purchase: 0, visitor: 0, pageview: 0 }, byHour: {}, lastSeen: null };
    }
  }

  function saveStats(stats) {
    try { localStorage.setItem(STATS_KEY, JSON.stringify(stats)); } catch(e) {}
  }

  function trackImpression(type) {
    var s = loadStats();
    s.impressions++;
    s.byType[type] = (s.byType[type] || 0) + 1;
    var h = new Date().getHours() + ':00';
    s.byHour[h] = (s.byHour[h] || 0) + 1;
    s.lastSeen = new Date().toISOString();
    saveStats(s);
  }

  function trackClick() {
    var s = loadStats();
    s.clicks++;
    saveStats(s);
  }

  // ── UTILS ─────────────────────────────────────────────────────────────────
  function rand(arr)     { return arr[Math.floor(Math.random() * arr.length)]; }
  function randInt(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
  function timeAgo()     { var m = randInt(1, 58); return m === 1 ? '1m ago' : m + 'm ago'; }

  function getProducts() {
    // Try data attribute injection first
    var el = document.getElementById('spw-data');
    if (el) {
      var products = [];
      var i = 1;
      while (el.dataset['p' + i]) {
        var parts = el.dataset['p' + i].split('|');
        products.push({ title: parts[0], img: parts[1] || '', url: parts[2] || '' });
        i++;
      }
      if (products.length) return products;
    }
    // Fall back to window variable
    if (window.__spwProducts && window.__spwProducts.length) return window.__spwProducts;
    return FALLBACK;
  }

  function cityLabel(city) {
    var d = CITY_DATA[city];
    return d ? d.flag + ' ' + city : '🌍 ' + city;
  }

  // ── STYLES ────────────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('spw-styles')) return;
    var isRight = CONFIG.position === 'bottom-right';
    var pos = isRight ? 'bottom:24px;right:24px;' : 'bottom:24px;left:24px;';
    var tx  = isRight ? '110%' : '-110%';
    var css = [
      '@import url("https://fonts.googleapis.com/css2?family=Inter:wght@500;600;700&display=swap");',
      '#spw-root{position:fixed;'+pos+'z-index:2147483647;display:flex;flex-direction:column-reverse;gap:10px;pointer-events:none;max-width:340px;}',
      /* Toast — darker bg with strong white text for contrast */
      '.spw-toast{display:flex;align-items:center;background:#1a1a1a;border:1px solid #333;border-radius:14px;box-shadow:0 12px 40px rgba(0,0,0,.7),0 2px 8px rgba(0,0,0,.5);width:340px;max-width:calc(100vw - 32px);pointer-events:auto;cursor:pointer;transform:translateX('+tx+') scale(.95);opacity:0;transition:transform .44s cubic-bezier(.22,1,.36,1),opacity .3s ease;position:relative;overflow:hidden;}',
      '.spw-toast.spw-show{transform:translateX(0) scale(1);opacity:1;}',
      '.spw-toast.spw-hide{transform:translateX('+tx+') scale(.95);opacity:0;}',
      '.spw-toast:hover{border-color:#444;box-shadow:0 16px 48px rgba(0,0,0,.8);}',
      /* Accent bar — thicker for visibility */
      '.spw-toast::before{content:"";position:absolute;left:0;top:0;bottom:0;width:4px;border-radius:14px 0 0 14px;}',
      '.spw-toast.spw-purchase::before{background:#C8FF00;}',
      '.spw-toast.spw-visitor::before{background:#4DA6FF;}',
      '.spw-toast.spw-pageview::before{background:#FF8C42;}',
      /* Image */
      '.spw-img{width:62px;height:62px;flex-shrink:0;margin:14px 0 14px 16px;border-radius:10px;overflow:hidden;background:#2a2a2a;display:flex;align-items:center;justify-content:center;font-size:26px;}',
      '.spw-img img{width:100%;height:100%;object-fit:cover;display:block;}',
      '.spw-toast.spw-visitor .spw-img{background:rgba(77,166,255,.15);border:1px solid rgba(77,166,255,.3);}',
      '.spw-toast.spw-pageview .spw-img{background:rgba(255,140,66,.15);border:1px solid rgba(255,140,66,.3);}',
      '.spw-toast.spw-purchase .spw-img{background:rgba(200,255,0,.1);border:1px solid rgba(200,255,0,.2);}',
      /* Body — generous padding */
      '.spw-body{flex:1;padding:14px 14px 14px 12px;min-width:0;}',
      /* Eyebrow — brighter, slightly bigger */
      '.spw-eye{font-family:"Inter",sans-serif;font-size:11px;font-weight:600;letter-spacing:.8px;text-transform:uppercase;margin-bottom:4px;}',
      '.spw-toast.spw-purchase .spw-eye{color:#C8FF00;}',
      '.spw-toast.spw-visitor .spw-eye{color:#5BB8FF;}',
      '.spw-toast.spw-pageview .spw-eye{color:#FF9F5A;}',
      /* Title — larger, pure white, clear font */
      '.spw-title{font-family:"Inter",sans-serif;font-size:15px;font-weight:700;color:#ffffff;line-height:1.35;margin-bottom:3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      /* Detail — noticeably brighter than before */
      '.spw-detail{font-family:"Inter",sans-serif;font-size:13px;font-weight:500;color:#cccccc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:3px;}',
      /* City — brighter, readable */
      '.spw-city{font-family:"Inter",sans-serif;font-size:12px;font-weight:500;color:#999999;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      /* Close button — bigger, easier to tap */
      '.spw-close{position:absolute;top:8px;right:8px;width:24px;height:24px;border-radius:6px;background:rgba(255,255,255,.08);border:none;color:#aaa;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;transition:all .15s;padding:0;line-height:1;}',
      '.spw-close:hover{background:rgba(255,255,255,.15);color:#fff;}',
      /* Progress bar */
      '.spw-prog{position:absolute;bottom:0;left:4px;right:0;height:3px;background:#2a2a2a;overflow:hidden;}',
      '.spw-prog-fill{height:100%;width:100%;transform-origin:left;}',
      '.spw-toast.spw-purchase .spw-prog-fill{background:#C8FF00;}',
      '.spw-toast.spw-visitor .spw-prog-fill{background:#4DA6FF;}',
      '.spw-toast.spw-pageview .spw-prog-fill{background:#FF8C42;}',
      '@keyframes spwProg{from{transform:scaleX(1)}to{transform:scaleX(0)}}',
    ].join('');
    var s = document.createElement('style');
    s.id = 'spw-styles'; s.textContent = css;
    document.head.appendChild(s);
  }

  function createRoot() {
    if (document.getElementById('spw-root')) return;
    var r = document.createElement('div');
    r.id = 'spw-root';
    document.body.appendChild(r);
  }

  // ── BUILD EVENT ───────────────────────────────────────────────────────────
  function buildEvent(forceType) {
    var type    = forceType || rand(CONFIG.types);
    var name    = rand(NAMES);
    var city    = rand(CITIES);
    var product = rand(getProducts());

    if (type === 'purchase') return {
      type: 'purchase', eyebrow: '🛒 Just Purchased',
      title: name + ' purchased', detail: product.title,
      city: cityLabel(city) + ' · ' + timeAgo(), img: product.img, url: product.url,
    };
    if (type === 'visitor') return {
      type: 'visitor', eyebrow: '👥 Live Now',
      title: randInt(8, 142) + ' people shopping',
      detail: 'on netxbrand.com now',
      city: '🌍 ' + randInt(8, 24) + ' countries represented',
      img: '', url: '',
    };
    return {
      type: 'pageview', eyebrow: '👁 Trending',
      title: name + ' is viewing', detail: product.title,
      city: cityLabel(city) + ' · ' + timeAgo(), img: product.img, url: product.url,
    };
  }

  // ── RENDER TOAST ──────────────────────────────────────────────────────────
  function showToast(ev) {
    if (!ev) return;
    var root = document.getElementById('spw-root');
    if (!root) return;
    var visible = root.querySelectorAll('.spw-toast');
    if (visible.length >= CONFIG.maxVisible) dismissToast(visible[0]);

    trackImpression(ev.type);

    var toast = document.createElement('div');
    toast.className = 'spw-toast spw-' + ev.type;

    var imgWrap = document.createElement('div');
    imgWrap.className = 'spw-img';
    if (ev.img) {
      var img = document.createElement('img');
      img.alt = ev.detail;
      img.onerror = function() { imgWrap.textContent = ev.type === 'purchase' ? '🛒' : ev.type === 'visitor' ? '👥' : '👁'; };
      img.src = ev.img;
      imgWrap.appendChild(img);
    } else {
      imgWrap.textContent = ev.type === 'purchase' ? '🛒' : ev.type === 'visitor' ? '👥' : '👁';
    }

    var body = document.createElement('div');
    body.className = 'spw-body';
    body.innerHTML =
      '<div class="spw-eye">'   + ev.eyebrow + '</div>' +
      '<div class="spw-title">' + ev.title   + '</div>' +
      '<div class="spw-detail">'+ ev.detail  + '</div>' +
      '<div class="spw-city">'  + ev.city    + '</div>';

    var close = document.createElement('button');
    close.className = 'spw-close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&#215;';
    close.addEventListener('click', function(e) { e.stopPropagation(); dismissToast(toast); });

    var prog = document.createElement('div');
    prog.className = 'spw-prog';
    var fill = document.createElement('div');
    fill.className = 'spw-prog-fill';
    fill.style.animation = 'spwProg ' + (CONFIG.duration / 1000) + 's linear forwards';
    prog.appendChild(fill);

    toast.appendChild(imgWrap);
    toast.appendChild(body);
    // Add a subtle arrow indicator for clickable product toasts
    if (ev.url) {
      var arrow = document.createElement('div');
      arrow.style.cssText = 'padding:0 12px 0 4px;color:#555;font-size:16px;flex-shrink:0;transition:color .15s;';
      arrow.textContent = '›';
      toast.appendChild(arrow);
      toast.addEventListener('mouseenter', function() { arrow.style.color = '#C8FF00'; });
      toast.addEventListener('mouseleave', function() { arrow.style.color = '#555'; });
    }
    toast.appendChild(close);
    toast.appendChild(prog);
    root.appendChild(toast);

    toast.addEventListener('click', function() {
      trackClick();
      clearTimeout(timer);
      if (ev.url) {
        window.location.href = ev.url;
      } else {
        dismissToast(toast);
      }
    });

    requestAnimationFrame(function() { requestAnimationFrame(function() { toast.classList.add('spw-show'); }); });
    var timer = setTimeout(function() { dismissToast(toast); }, CONFIG.duration);
  }

  function dismissToast(toast) {
    if (!toast || !toast.parentElement) return;
    toast.classList.remove('spw-show');
    toast.classList.add('spw-hide');
    setTimeout(function() { if (toast.parentElement) toast.parentElement.removeChild(toast); }, 500);
  }

  function loop() {
    showToast(buildEvent());
    setTimeout(loop, randInt(CONFIG.interval[0], CONFIG.interval[1]));
  }

  function init() {
    injectStyles();
    createRoot();
    setTimeout(loop, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
